import React, { useState, useEffect } from 'react';
import "./Feed.css";
import PostBox from './PostBox';
import Post from "./Post";
import { db } from "../firebase";
import { useHistory } from "react-router-dom";
import FlipMove from "react-flip-move"

function Feed({ user }) {
    const [posts, setPosts] = useState([]);
    const history = useHistory("");

    if (user === false) {
      history.push("/");
    }

    useEffect(() => {
        // This is where the code runs
        db.collection('posts').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
          // every time a new post is added, this code fires
          setPosts(snapshot.docs.map(doc => ({
            id: doc.id,
            post: doc.data()
          })));
        })
      }, []);

    return (
        <div className="feed">
            <PostBox />
            <FlipMove>
            {
              posts.map(({id, post}) => [
                <Post key={id} postId={id} user={user} username={post.username} caption={post.caption} imageUrl={post.imageUrl} photoURL={post.photoURL} uid={post.uid} likes={post.likes} timestamp={post.timestamp} />
              ])
            }
            </FlipMove>
        </div>
    )
}

export default Feed;